/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "letter-open-b25cc0d5--sprite",
  "use": "letter-open-b25cc0d5--sprite-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"letter-open-b25cc0d5--sprite\"><g transform=\"translate(36 36) rotate(180)\"><g transform=\"translate(36 36) rotate(180)\" opacity=\"0\"><g fill=\"#fff\" stroke=\"#707070\" stroke-width=\"1\" opacity=\"0.5\"><rect width=\"36\" height=\"36\" stroke=\"none\" /><rect x=\"0.5\" y=\"0.5\" width=\"35\" height=\"35\" fill=\"none\" /></g></g></g><g transform=\"translate(8.4 12.846)\"><path d=\"M465.059,376.3v7.481a2.117,2.117,0,0,1-2.118,2.118H448.118A2.117,2.117,0,0,1,446,383.778V376.3a.529.529,0,0,1,.823-.44l8.707,5.8,8.707-5.8A.529.529,0,0,1,465.059,376.3Z\" transform=\"translate(-446 -373.19)\" fill=\"currentColor\" /><path d=\"M463.536,374.3l-8.075,5.383-8.075-5.383a.529.529,0,0,1,.293-.97h15.563A.529.529,0,0,1,463.536,374.3Z\" transform=\"translate(464.991 374.84) rotate(180)\" fill=\"currentColor\" /></g></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
